import { Controller } from "@hotwired/stimulus"

// Arrow-key navigation between a campaign's last/this/next week missions in
// the Missions Planning detail modal.
//
// Mirrors response_modal_controller's ArrowLeft/ArrowRight behaviour so the
// two modals feel the same, without modifying it -- that controller is shared,
// heavier, and purpose-built for response galleries (it tracks gallery indexes
// and drives frame src itself). Here the chevrons are plain links that already
// navigate the frame, so this only has to forward the keystroke to them.
//
// Targets are only present when a mission exists in that direction, so at the
// ends of the range the key simply does nothing rather than hitting a dead
// control.
export default class extends Controller {
  static targets = ["prev", "next"]

  connect() {
    this.onKeyDown = this.handleKeyDown.bind(this)
    document.addEventListener("keydown", this.onKeyDown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeyDown)
  }

  handleKeyDown(event) {
    // Never steal arrow keys from something the user is typing in -- this
    // modal carries a rich-text brief editor and a target-responses field.
    const el = event.target
    if (el && (el.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName))) return
    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return

    if (event.key === "ArrowLeft" && this.hasPrevTarget) {
      event.preventDefault()
      this.prevTarget.click()
    } else if (event.key === "ArrowRight" && this.hasNextTarget) {
      event.preventDefault()
      this.nextTarget.click()
    }
  }
}
